"use server";

import { redirect } from "next/navigation";
import bcrypt from "bcryptjs";
import { prisma } from "@/lib/prisma";
import { createSessionCookie, destroySessionCookie, type Role } from "@/lib/session";
import { lockedRemainingMinutes, registerFailedLogin, resetLoginAttempts } from "@/lib/loginThrottle";

export type LoginState = { error?: string };

export async function login(_prevState: LoginState, formData: FormData): Promise<LoginState> {
  const email = String(formData.get("email") ?? "").trim().toLowerCase();
  const password = String(formData.get("password") ?? "");

  if (!email || !password) {
    return { error: "יש למלא אימייל וסיסמה" };
  }

  const user = await prisma.user.findUnique({ where: { email } });

  const remainingLockMinutes = user ? lockedRemainingMinutes(user) : null;
  if (remainingLockMinutes != null) {
    return { error: `יותר מדי ניסיונות כושלים. נסה/י שוב בעוד ${remainingLockMinutes} דקות.` };
  }

  // Compare against a dummy hash when the user doesn't exist so the response
  // time doesn't reveal whether the email is registered.
  const hash = user?.passwordHash ?? "$2b$10$CwTycUXWue0Thq9StjUM0uJ8/hqO/ZY3E7XlF0YyE7z1p4vP0T9Xa";
  const valid = await bcrypt.compare(password, hash);

  if (!user || !valid) {
    if (user) await registerFailedLogin(user.id);
    return { error: "אימייל או סיסמה שגויים" };
  }

  await resetLoginAttempts(user.id);
  await createSessionCookie({ userId: user.id, email: user.email, role: user.role as Role });
  redirect("/");
}

export async function logout() {
  await destroySessionCookie();
  redirect("/login");
}
